<!-- <p>add-data-model-node works!</p> -->
<app-dialog-header headerIcon="add" headerText="Create New Child Node {{parentNode ? 'for ' + parentNode.Name : ''}}"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
    <div class="main-div">
        <div class="content">
            <div class="node-type-options alignRow">
                <span>Node Type:</span>
                <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='nodeTypes' [fields]="nodeTypeFields"
                    formControlName="NodeType" placeholder="Node Type" (change)="nodeTypeChange($event)">
                    <ng-template #itemTemplate let-data>
                        <div>
                            <span>{{ data.text.replace(data.text[0], data.text[0].toUpperCase()) }}</span>
                        </div>
                    </ng-template>
                </ejs-dropdownlist>
            </div>
            <div class="sensor-list" *ngIf="selectedNodeType == 1">
                <ejs-listview id='listview' #listview [dataSource]='sensors' cssClass='e-list-template'>
                    <ng-template #template let-dataSource>
                        <div class="sensor-item ejs-listview-item alignRow">
                            <div class="sensor-name">
                                <span>{{dataSource.Name}}<span *ngIf="dataSource.Description != ''">{{' - ' +
                                        dataSource.Description}}</span></span>
                                <span>{{dataSource.Datapoints.length}} DataPoint{{dataSource.Datapoints.length != 1 ?
                                    's' : ''}}</span>
                            </div>
                            <mat-checkbox color="primary" (change)="toggleSensor($event, dataSource)"></mat-checkbox>
                        </div>
                    </ng-template>
                </ejs-listview>
            </div>
            <div class="selected-sensors" *ngIf="selectedNodeType == 1">
                <span>Selected Sensors: </span>
                <span *ngFor="let sensor of selectedSensors; let idx = index"><b>{{sensor.Name}}</b>{{idx !=
                    selectedSensors.length - 1 ? ', ' : ''}}</span>
            </div>
            <mat-form-field appearance="fill" *ngIf="selectedNodeType == 0">
                <mat-label>Name</mat-label>
                <input matInput autocomplete="off" formControlName="Name">
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="selectedNodeType == 0">
                <mat-label>Description</mat-label>
                <input matInput autocomplete="off" formControlName="Description">
            </mat-form-field>
        </div>
        <div mat-dialog-actions>
            <button mat-button [mat-dialog-close]="dialogForm.value"
                [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
            <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
        </div>
    </div>
</form>